import React from "react";
import Child from "assets/child.png";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
// form & validsation
import * as yup from "yup";
import { FormError, FormLabel, FormInput } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import { Button } from "components/Basic/Button";
import { useToggle } from "hooks";
import { Modal } from "components/Basic/Modal";

// schema
const schema = yup.object().shape({
  children_add: yup
    .object()
    .shape({
      child_age: yup.string().required("You must provide a value"),
      child_gender: yup.string().required("You must provide a value"),
      child_parentage: yup.string().required("You must provide a value"),
    })
    .required(),
});

export function Step07({ onSubmit, store, handleBackClick }) {
  const { toggleOn, onToggleClick } = useToggle();

  const [children, setChildren] = React.useState(
    store.children.children_add || []
  );
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  const handleData = () => {
    const merger_current_values = { ...store.children, children_add: children };
    const mergeToStore = { ...store, children: merger_current_values };
    onSubmit(mergeToStore);
  };

  const addChild = (values) => {
    console.log(store.children);
    if (
      store.children.if_children_together === "" &&
      store.children.if_children_partner_another === "" &&
      store.children.if_children_user_another === "" &&
      store.children.if_children_together === "No" &&
      store.children.if_children_partner_another === "No" &&
      store.children.if_children_user_another === "No"
    ) {
      onToggleClick();
    } else setChildren([...children, values.children_add]);
    reset();
  };

  const removeChild = (index) => {
    const copydata = children.slice();
    copydata.splice(index, 1);
    setChildren(copydata);
  };

  return (
    <>
      <form id="divorce-form" onSubmit={handleSubmit(addChild)}>
        <section>
          <p className={customClasses.questionText}>
            Please add both your and{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}
            ’s children
          </p>

          <>
            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`children_add.child_age`}
                className={customClasses.questionText}
                error={errors?.children_add?.child_age?.message}
              >
                Child's age (years)
              </FormLabel>
              <article>
                <FormInput
                  placeholder="Enter Child Age"
                  id={`children_add.child_age`}
                  type="text"
                  name={`children_add.child_age`}
                  error={errors?.children_add?.child_age?.message}
                  register={register}
                />
              </article>
            </section>

            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`children_add.child_gender`}
                className={customClasses.questionText}
                error={errors?.children_add?.child_gender?.message}
              >
                Child's gender
              </FormLabel>
              <article>
                <FormInput
                  placeholder="Enter Child Gender"
                  id={`children_add.child_gender`}
                  type="text"
                  name={`children_add.child_gender`}
                  error={errors?.children_add?.child_gender?.message}
                  register={register}
                />
              </article>
            </section>

            <section className="pb-6 md:pb-5">
              <FormLabel
                htmlFor={`children_add.child_parentage`}
                className={customClasses.questionText}
                error={errors?.children_add?.child_parentage?.message}
              >
                Who's are the parents?
              </FormLabel>
              <article>
                <FormInput
                  placeholder="Enter Parentage Details"
                  id={`children_add.child_parentage`}
                  type="text"
                  name={`children_add.child_parentage`}
                  error={errors?.children_add?.child_parentage?.message}
                  register={register}
                />
              </article>
            </section>
          </>

          <Button
            bgColor="bg-gray-300"
            className="text-xl font-bold px-10 py-3 mb-10 m-auto block focus:outline-none"
            textColor="black"
            borderColor="native-300"
            borderWidth="border-2"
            type="submit"
            form="divorce-form"
          >
            + Add Child
          </Button>

          <section>
            {children?.length
              ? children?.map((d, i) => (
                  <>
                    <div
                      key={i}
                      className="shadow-xl rounded-md border border-gray-100 mt-2 py-3 bg-white flex justify-between items-center px-2 relative"
                    >
                      <div>
                        <img src={Child} className="w-12" alt="child" />
                      </div>
                      <div className="absolute left-16">
                        <div>
                          <b>Age</b>: {d.child_age}
                        </div>
                        <div>
                          <b>Gender</b>: {d.child_gender}
                        </div>
                        <div>
                          <b>Parents</b>: {d.child_parentage}
                        </div>
                      </div>
                      <div
                        className="w-7 h-7 rounded-full bg-red-500 flex justify-center items-center cursor-pointer"
                        onClick={() => removeChild(i)}
                      >
                        <CloseIcon className="text-white" />
                      </div>
                    </div>
                  </>
                ))
              : null}
          </section>

          <section className="flex justify-center mt-10	">
            <WarningIcon fontSize="large" />
            <p className="text-center text-lg ml-5 italic">
              Please add all your children before continuing. Click the button
              above to add each child separately
            </p>
          </section>

          <Button
            bgColor={children.length ? "bg-native-300" : "bg-gray-100"}
            disabled={!children.length}
            onClick={handleData}
            fontSize="lg"
            form="divorce-form"
            className="w-32 m-auto block p-2 py-1 mt-8 focus:outline-none hover:bg-native-300  hover:border-native-300"
          >
            Next
          </Button>
        </section>
      </form>
      <Modal onToggleClick={onToggleClick} toggleOn={toggleOn}>
        <p className="text-center text-3xl">Error</p>
        <p className="text-center">Please add value to previous step</p>
        {store.children.if_children_together === "No" &&
        store.children.if_children_partner_another === "No" &&
        store.children.if_children_user_another === "No" ? (
          <p className="text-center">
            You are required to mark 'Yes', any of previous step question to add
            child
          </p>
        ) : (
          <p className="text-center"></p>
        )}
        <div className="flex items-center justify-center mt-6	 ">
          <Button
            onClick={() => {
              handleBackClick();
              onToggleClick();
            }}
            className=" w-5/12 font-medium mx-3 md:mx-0 p-4 bg-native-200 hover:bg-native-300 shadow-lg border-native-200"
          >
            Continue to previous step
          </Button>
        </div>
      </Modal>
    </>
  );
}
